import SearchInput from "../common/SearchInput";
import RenderIf from "../render-if/Renderif";
import XButton from "../common/XButton";
import PageTitle from "../common/PageTitle";

const rowClasses = "row items-center";

const titleColClasses = "col-md-6";

const controlsColClasses = "col-md-6 flex justify-end";

// The Arches listing header pairs a 240px search field with a 120px action, both
// 44px tall, rather than letting the field stretch across the half-column.
const searchWrapperClasses = "relative w-full max-w-60";

const addButtonClasses = "ml-4! min-w-30 h-11";

const ListingCardHeader = ({ title, handleSearchChange, btnText, onBtnClick }) => {
    return (
        <div className={rowClasses}>
            <div className={titleColClasses}>
                <PageTitle title={title} />
            </div>
            <div className={controlsColClasses}>
                <div className={searchWrapperClasses}>
                    <SearchInput debouncedHandleSearchChange={handleSearchChange} placeholderText="Search ..." />
                </div>
                <RenderIf shouldRender={btnText}>
                    <XButton onClick={onBtnClick} className={addButtonClasses}>
                        <i className="fa-solid fa-plus"></i> {btnText}
                    </XButton>
                </RenderIf>
            </div>
        </div>
    )
}

export default ListingCardHeader;